import { useTranslation } from 'react-i18next';

import { Badge } from '~/components/ui/badge';

interface ExpectationsResultProps {
  questionText: string;
  verdict: string | null;
  reasoning: string;
  evidence: string;
}

export function ExpectationsResult({
  questionText,
  verdict,
  reasoning,
  evidence
}: ExpectationsResultProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <h2 className="text-base font-semibold">{t('scoring.expectations')}</h2>
      <div className="rounded-lg border border-border bg-card p-4 shadow-sm border-l-4 border-l-[var(--color-section-green)]">
        <div className="flex items-start justify-between gap-2">
          <p className="text-sm font-medium">{questionText}</p>
          <Badge variant={verdict === 'pass' ? 'default' : 'destructive'} className="shrink-0">
            {t(`scoring.verdicts.${verdict ?? 'fail'}` as 'scoring.verdicts.pass')}
          </Badge>
        </div>
        <div className="mt-2 flex flex-col gap-1">
          <p className="text-sm text-muted-foreground">
            <span className="font-medium">{t('scoring.reasoning')}:</span> {reasoning}
          </p>
          <p className="text-sm italic text-muted-foreground">&ldquo;{evidence}&rdquo;</p>
        </div>
      </div>
    </div>
  );
}
